export class MainRepository {
  constructor(gaApp, endpoints) {
    this.gaApp = gaApp

    this.endpoints = gaApp.api.endpoints(endpoints)
  }

  async fetchProductsBySku(params, requestOptions = {}) {
    const { url } = this.endpoints.fetchProductsBySku()

    try {
      const response = await this.gaApp.api
        .request(requestOptions)
        .post(url, params)

      return this.gaApp.api.response(response)
    } catch (error) {
      throw this.gaApp.api.error(error)
    }
  }

  async fetchCatalogProducts(params, requestOptions = {}) {
    const { url } = this.endpoints.fetchCatalogProducts()

    try {
      const response = await this.gaApp.api
        .request({ apiType: 'webBff', ...requestOptions })
        .post(url, params)

      return this.gaApp.api.response(response)
    } catch (error) {
      throw this.gaApp.api.error(error)
    }
  }
}
